import React from "react";
import Icon from "../../../components/AppIcon";

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-500 via-primary/90 to-yellow-600 min-h-[60vh] flex items-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-white">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Award" size={24} color="white" />
              </div>
              <span className="text-accent-foreground bg-accent/20 px-4 py-2 rounded-full text-sm font-medium">
                Excellence in Technical Education
              </span>
            </div>

            <h1 className="text-4xl lg:text-4xl font-bold mb-6 leading-tight">
              About{" "}
              <span className="text-yellow-600">
                KARUMO TECHNICAL TRAINING INSTITUTE
              </span>
            </h1>

            <p className="text-xl lg:text-xl mb-8 text-white/90 leading-relaxed text-justify">
              Karumo Technical Training Institute (Karumo TTI) is a public
              tertiary institution under the Ministry of Education, State
              Department for Vocational and Technical Training. Established in
              2015 (Registration No. RC/0006/2014), the institute is located in
              Athwana Location, Tigania West Sub-county, Meru County — about 3
              km off the Meru–Maua road along Kwa Amos Junction–Isiolo road.
              Karumo TTI boasts a conducive learning environment with reliable 
              road access and favorable conditions for training and innovation.
            </p>

            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                <Icon name="Users" size={20} color="white" />
                <span className="text-sm font-medium">Best User Experience</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                <Icon name="Trophy" size={20} color="white" />
                <span className="text-sm font-medium">
                  10+ Years Excellence
                </span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                <Icon name="Building2" size={20} color="white" />
                <span className="text-sm font-medium">Dual TVET Program</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative z-10 w-full h-full object-cover">
              <video
                src="/assets/arial1.mp4"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
                autoPlay
                muted
                loop
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-full h-full bg-accent/20 rounded-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
